import { ref, getDatabase, query, orderByChild, equalTo } from "firebase/database";
import { useListVals } from "react-firebase-hooks/database";
import { useMemo } from "react";

export default function PatientSelect({setSelectedCase, setSelectedEval, gender, activeCustomer}) {

    // Query Realtime Database 'results' collection, matching Python's approach
    // Note: Python's pyrebase wraps values in quotes for the REST API, but JS SDK doesn't need this
    const resultsRef = query(
        ref(getDatabase(), 'results'),
        orderByChild('cus_id'),
        equalTo(activeCustomer)
    );

    const [allValues, loading, error] = useListVals(resultsRef, { keyField: 'id' });

    // Filter by gender in code (like Python does) rather than in query
    const values = useMemo(() => {
        if (!allValues) return [];
        return allValues.filter(val => val?.eval_data?.client?.Sex === gender);
    }, [allValues, gender]);

    /**
     * Select the case from the values list
     * @param value - the case_num to find
     */
    function getCase(value) {
        if (!values || values.length === 0) {
            return null;
        }

        for (let doc of values) {
            if (doc.eval_data.case_num === value) {
                // Use eval_id from the document (matches Python's result_data['eval_id'])
                setSelectedEval(doc.eval_id || doc.id);
                return doc;
            }
        }

        return null;
    }

    // Sort values by case number (don't mutate original array)
    const sortedValues = useMemo(() => {
        if (!values || values.length === 0) return [];

        function getCaseNum(doc) {
            const num = doc?.eval_data?.case_num || "0";
            const parts = num.split("-");
            return parseInt(parts[parts.length - 1]) || 0;
        }

        return [...values].sort((a, b) => getCaseNum(b) - getCaseNum(a));
    }, [values]);

    return (
        <div className="py-10">
            <label htmlFor="location" className="text-base font-semibold text-gray-900">
                Case Number
            </label>
            <select
                id="casenum"
                name="casenum"
                className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                defaultValue="Select Case Number"
                onChange={(e) => {
                    const value = e.target.value;
                    setSelectedCase(getCase(value));
                }}
            >
                <option value="">Select Case Number</option>
                {loading ? (
                    <option>Loading, please wait</option>
                ) : sortedValues.map((value) => (
                    <option key={value.eval_data.case_num} value={value.eval_data.case_num}>
                        {value.eval_data.case_num}{value.eval_data.client?.name ? ` - ${value.eval_data.client.name}` : ''}
                    </option>
                ))}
            </select>
        </div>
    )
}